import { person } from '../../api/person';
import { IframeWindow } from '.';
import { BaseRequest } from 'api';

export class Person implements person.Api {
  constructor(private iframe: IframeWindow) {}

  selectPerson(request?: person.SelectPersonRequest): Promise<person.Person[]> {
    return this.iframe.twoWayCall<person.SelectPersonRequest, person.Person[]>(
      request,
      (requestId, request) => {
        this.iframe.postMessage({
          command: 'person.selectPerson',
          args: {
            ...request,
            requestId,
          },
        });
      },
      (response) => {
        let responseData;
        try {
          responseData = JSON.parse(response);
        } catch (e) {
          // Unable to parse response => response is not a stringify object
          responseData = response;
        }
        return responseData;
      }
    );
  }

  openPerson(request: person.OpenPersonRequest): void {
    this.iframe.postMessage({
      command: 'person.openPerson',
      args: request,
    });
  }

  //   getLists(request: BaseRequest): Promise<person.Person[]> {
  //     return this.iframe.twoWayCall<BaseRequest, person.Person[]>(
  //       request,
  //       (requestId, request) => {
  //         this.iframe.postMessage({
  //           command: 'person.getLists',
  //           args: {
  //             ...request,
  //             requestId,
  //           },
  //         });
  //       },
  //       (response) => {
  //         let responseData;
  //         try {
  //           responseData = JSON.parse(response);
  //         } catch (e) {
  //           // Unable to parse response => response is not a stringify object
  //           responseData = response;
  //         }
  //         return responseData;
  //       }
  //     );
  //   }
}
